import PropTypes from 'prop-types';
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogContent, Typography, Stack } from '@mui/material';
import FormProvider from '@/components/hook-form/FormProvider';
import { RHFMultiSelect } from '@/components/hook-form';
import { FormScopes } from '@/utils/form';
import useAppSendTestEventModal from './useAppSendTestEventModal';
import TestEventResults from './TestEventResults';

AppSendTestEventModal.propTypes = {
  scope: PropTypes.string,
  setScope: PropTypes.func,
  platform: PropTypes.any,
  selectedApp: PropTypes.any,
  onViewLogs: PropTypes.func,
};

export default function AppSendTestEventModal({
  scope,
  setScope,
  platform,
  selectedApp,
  onViewLogs,
}) {
  const events = platform?.events || [];
  const platformName = platform?.name || 'integração';

  const { form, onSubmit, isLoading, results, clearResults } = useAppSendTestEventModal({
    appId: selectedApp?.id,
    setScope,
    platform,
  });

  const onClose = () => {
    setScope(FormScopes.INDEX);
    form.reset();
    clearResults();
  };

  const handleViewLogs = () => {
    onClose();
    onViewLogs();
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={scope === FormScopes.SEND_TEST_EVENT} onClose={onClose}>
      <DialogContent sx={{ py: 2 }}>
        <FormProvider methods={form} onSubmit={onSubmit}>
          <Stack gap={3}>
            <Typography variant="h5">Enviar evento de teste de {platformName}</Typography>

            <Stack gap={2}>
              <RHFMultiSelect
                size="small"
                chip
                checkbox
                options={events.map(({ custom_id, name }) => ({ value: custom_id, label: name }))}
                name="events"
                placeholder="Selecione os eventos"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Stack>

            {results.length > 0 && (
              <TestEventResults
                results={results}
                events={events}
                onViewLogs={onViewLogs ? handleViewLogs : undefined}
              />
            )}

            <Stack direction="row" justifyContent="flex-end" spacing={1}>
              <LoadingButton variant="contained" type="submit" loading={isLoading}>
                Enviar
              </LoadingButton>
            </Stack>
          </Stack>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
}
